import React from 'react';
import './Newsletter.css';
import page from '../../assets/Bg.jpeg';
function Newspop() {
    return (
        <div className="newsletter-popup">
            <div className="newsletter-image" />
            {/* <img src={page} alt='newsletter'/> */}
            <div className="newsletter-content">
                <button className="newsletter-close">×</button>
                <h2 className="newsletter-heading">Subscribe to our Newsletter</h2>
                <p className="newsletter-subtext">
                    Subscribe to our newsletter and save 20% with a discount code today.
                </p>
                <div className="newsletter-input-container">
                    <input type="email" placeholder="Enter your email" />
                    <button>Subscribe</button>
                </div>
                <label className="newsletter-checkbox">
                    <input type="checkbox" />
                    Do not show this window
                </label>
            </div>
        </div>

    );
}
export default Newspop;